import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormDescription, FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Switch } from '@fortem-monorepo/react-ui'

import { GuidelineFormValues } from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'

interface ActiveFieldProps {}

export const ActiveField: React.FC<ActiveFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<GuidelineFormValues>()

  return (
    <FormField
      name="is_active"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Active</FormLabel>
              <FormError />
            </div>
            <FormDescription>Toggle the guideline</FormDescription>
            <Switch
              checked={value}
              onCheckedChange={(val) =>
                setValue('is_active', val, { shouldValidate: true, shouldDirty: true })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
